var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.445 48.695c9.315 0 16.866-7.563 16.866-16.892S33.76 14.911 24.445 14.911c-9.316 0-16.867 7.563-16.867 16.892 0 9.33 7.551 16.892 16.867 16.892z",
    fill: "#FFD6C0",
    stroke: "#FFD6C0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.487 48.778c-3.855 5.303-9.043 7.444-16.376 7.444 3.513-2.342 7.025-6.927 8.389-10.532l7.987 3.088z",
    fill: "#FFD6C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.556 67.32c9.315 0 16.866-7.551 16.866-16.867 0-9.315-7.551-16.866-16.866-16.866-9.316 0-16.867 7.551-16.867 16.866 0 9.316 7.551 16.867 16.867 16.867z",
    fill: "#FFD6C0",
    stroke: "#FFD6C0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.513 67.454c3.855 5.303 9.043 7.444 16.376 7.444-3.513-2.342-7.025-6.927-8.389-10.532l-7.987 3.088z",
    fill: "#FFD6C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.889 34.222a2.444 2.444 0 100-4.889 2.444 2.444 0 000 4.89zM24.444 34.222a2.445 2.445 0 100-4.889 2.445 2.445 0 000 4.89zM33 34.222a2.444 2.444 0 100-4.889 2.444 2.444 0 000 4.89z",
    fill: "#2D2F33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 45.69c-1.364 3.605-4.876 8.19-8.389 10.532 7.333 0 12.52-2.141 16.376-7.444",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.225 48.664c8.128-1.328 14.33-8.383 14.33-16.886 0-9.45-7.66-17.111-17.11-17.111s-17.112 7.66-17.112 17.11a17.04 17.04 0 003.802 10.756",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.111 52.898a2.444 2.444 0 100-4.89 2.444 2.444 0 000 4.89zM63.556 52.898a2.444 2.444 0 100-4.889 2.444 2.444 0 000 4.889zM55 52.898a2.444 2.444 0 100-4.889 2.444 2.444 0 000 4.889z",
    fill: "#2D2F33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 64.366c1.364 3.605 4.876 8.19 8.389 10.532-7.333 0-12.52-2.141-16.376-7.444",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.775 67.34c-8.128-1.328-14.33-8.383-14.33-16.887 0-9.45 7.66-17.11 17.11-17.11s17.112 7.66 17.112 17.11a17.04 17.04 0 01-3.802 10.755",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

export default SvgChatting;